module.exports = __webpack_public_path__ + "static/img/img-home-co-22.79deb78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-22.png
// module id = mCY3
// module chunks = 1